<div class="badge" *ngIf="content > 0">
  <div class="badge-content"><span class="text-tiny-normal">{{content}}</span></div>
</div>
